import { render, staticRenderFns } from "./auth-telegram.vue?vue&type=template&id=80d46b62&scoped=true"
import script from "./auth-telegram.vue?vue&type=script&lang=js"
export * from "./auth-telegram.vue?vue&type=script&lang=js"
import style0 from "./auth-telegram.vue?vue&type=style&index=0&id=80d46b62&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80d46b62",
  null
  
)

export default component.exports